import { basisURL } from "@/request/config";

/**
 * 饮食解读图片字段：逗号分隔或 JSON 数组字符串；补全为可访问的绝对地址（静态资源在服务端 context-path 下）
 */
export function parseDietImages(img) {
  if (img == null || img === "") return [];
  const s = String(img).trim();
  if (!s) return [];
  if (s.startsWith("[")) {
    try {
      const arr = JSON.parse(s);
      return Array.isArray(arr)
        ? arr.map(String).map((x) => x.trim()).filter(Boolean)
        : [s];
    } catch (e) {
      return s.split(",").map((x) => x.trim()).filter(Boolean);
    }
  }
  return s.split(",").map((x) => x.trim()).filter(Boolean);
}

export function resolveMediaUrl(u) {
  if (u == null || u === "") return "";
  const p = String(u).trim();
  if (!p) return "";
  if (/^https?:\/\//i.test(p) || p.startsWith("//")) return p;
  const base = String(basisURL || "").replace(/\/$/, "");
  if (!base) return p.startsWith("/") ? p : "/" + p;
  return p.startsWith("/") ? base + p : base + "/" + p;
}
